import api from "../apiConfig";

export const BorderCategory = async () => {
  try {
    const resp = await api.get("/api/board/category");
    return resp;
  } catch (error) {
    console.log("보터 카테고리 호출 Error", error);
    return error;
  }
};

export const BorderListAPI = async ({ limit, page, category_id }) => {
  try {
    const resp = await api.get("/api/board/", {
      params: {
        limit,
        page,
        category_id,
      },
    });

    return resp;
  } catch (error) {
    console.log("보더 리스트 호출 Error", error);
    return error;
  }
};

export const BorderGetApi = async (id, pw, token) => {
  try {
    const resp = await api.post(`/api/board/get/${id}`, {
      password: pw,
      is_token: token,
    });

    return resp;
  } catch (error) {
    console.log("게시판 내용 확인 Error", error);
    return error;
  }
};

export const BorderCreate = async (
  title,
  company,
  category,
  email,
  content,
  pw,
  phone,
  name
) => {
  try {
    const resp = await api.post("/api/board/create", {
      title: title,
      company: company,
      category_id: category,
      email: email,
      content: content,
      password: pw,
      phone: phone,
      name: name,
    });

    return resp;
  } catch (error) {
    console.log("게시판 생성 실패", error);
    return error;
  }
};

export const BorderDelete = async (id) => {
  try {
    const resp = await api.delete(`/api/board/suggestion/${id}`);

    return resp;
  } catch (error) {
    console.log("삭제 Error ", error);
    return error;
  }
};

export const BorderPut = async (
  id,
  title,
  company,
  category,
  email,
  content,
  password,
  phone,
  name
) => {
  try {
    const resp = await api.put(`/api/board/suggestion/${id}`, {
      title: title,
      company: company,
      category_id: category,
      email: email,
      content: content,
      password: password,
      phone: phone,
      name: name,
    });

    return resp;
  } catch (error) {
    console.log("수정 Error", error);
    return error;
  }
};

export const CommentCreat = async (id, content, writer, sbid) => {
  try {
    const resp = await api.post("/api/board/suggestion/comment", {
      parent_id: null,
      content: content,
      is_writer: writer,
      sb_id: sbid,
    });
    return resp;
  } catch (error) {
    console.log("댓글달기 실패", error);
    return error;
  }
};

export const CommentCreat2 = async (id, content, writer, sbid) => {
  try {
    const resp = await api.post("/api/board/suggestion/comment", {
      parent_id: id,
      content: content,
      is_writer: writer,
      sb_id: sbid,
    });
    return resp;
  } catch (error) {
    console.log("댓글달기 실패", error);
    return error;
  }
};

export const CommentDelete = async (id) => {
  try {
    const resp = await api.delete(`/api/board/suggestion/comment/${id}`);

    return resp;
  } catch (error) {
    console.log("댓글삭제 Error", error);
    return error;
  }
};

export const CommentPut = async (id, content) => {
  try {
    const resp = await api.put(`/api/board/suggestion/comment/${id}`, {
      content: content,
    });
    return resp;
  } catch (error) {
    console.log("댓글수정 실패", error);
    return error;
  }
};
